<template>
  <div class="chart-block">
    <h3>
      {{ chartName }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="primary" dark v-bind="attrs" v-on="on">
            mdi-progress-question
          </v-icon>
        </template>
        <div>{{ tip }}</div>
      </v-tooltip>
      <span>{{ updated }}</span>

    </h3>
    <div style="display: flex" loading>
      <div class="n4i-left">
        <div class="total">{{ index() }}</div>
        <div class="y">{{ date() }}</div>
      </div>
      <div
        id="chart_n4index"
        class="chart-box"
        style="padding-bottom: 9px; flex: auto;"
      ></div>
    </div>
  </div>


</template>
<script>
    import echarts from 'echarts'
    export default {
        props: {
           chartName:{type:String,default:'历年车身形式销量变化'}
        },
        data() {
            return {
                chartOption: {}
            }
        },
        mounted() {
            let myChart = echarts.init(document.getElementById('chart_nesm'));
            this.chartOption = {};
            myChart.setOption(this.chartOption);
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            window.addEventListener('resize', function() {
                myChart.resize()
            });
        },
        methods: {},
        watch: {},
        created() {}
    }
</script>
 